import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Back from "shared/assets/images/svg/back_blue.svg";
import Input from "shared/component/inputFields";
import { useChangePassword } from "customer/settings/changePassword/change-password.service";
import { Spinner } from "react-bootstrap";
import Info from 'shared/assets/images/svg/info_gr.svg'

const ChangePassword = () => {
  const {t}=useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    isLoading
  } = useChangePassword();

  return (
    <div className="settingHome changePassword">
      <div className="container">
        <div className="header">
          <div className="page-name">
            <Link className="linkBack" to="/settings">
              <img src={Back} alt="back" />
            </Link>
            <h1>{t('change-password.change')}</h1>
          </div>
        </div>
        <hr className="hr" />
        <form
          className="col-lg-5 col-md-6"
          onSubmit={(e) => {
            e.preventDefault();
            return handleSubmit();
          }}
        >
          <div className="form-group form-div mt-0 row g-3 align-items-center">
            <label className="col-lg-4 col-form-label ">
            {t('change-password.current')}:
            </label>
            <div className="col-lg-8">
              <Input
                type="password"
                {...register("oldPassword")}
                error={errors.oldPassword?.message}
              />
            </div>
          </div>
          <div className="form-group form-div mt-0 row g-3 align-items-center">
            <label className="col-lg-4 col-form-label ">
            {t('change-password.new')}:
            </label>
            <div className="col-lg-8">
            <Input
            type="password"
            // warning="use 8 or more characters with a mix of letters, numbers & symbols."
            {...register("newPassword")}
            error={errors.newPassword?.message}
          />
            </div>
          </div>
          <div className="form-group form-div mt-0 row g-3 align-items-center">
            <label className="col-lg-4 col-form-label ">
            {t('change-password.confirm')}:
            </label>
            <div className="col-lg-8">
            <Input
            type="password"
            {...register("confirmNewPassword")}
            error={errors.confirmNewPassword?.message}
          />
            </div>
          </div>




          {/* <div className="restPassword">
        <img src={Info} alt="Info" />
              <p> {t('change-password.remember')} <Link to="">{t('change-password.reset')}</Link> </p>
        </div> */}
        </form>

      </div>
      <div className="action">
        <div className="container">
          <button disabled={isLoading} className="btn-blue" onClick={() => handleSubmit()}>
            <Spinner animation='border' size='sm' hidden={!isLoading} />
            {t('change-password.save')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
